module.exports = __webpack_public_path__ + "static/media/add stock.e844b9c4.svg";